var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinistriesNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.057,
    height: 31.199,
    viewBox: "0 0 34.057 31.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(-305.369 -149.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M15.871.821a2,2,0,0,1,2.315,0L28.941,8.454a2,2,0,0,1-1.157,3.631H6.274A2,2,0,0,1,5.116,8.454Z",
    transform: "translate(305.369 149.801)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1_-_Outline",
    "data-name": "Polygon 1 - Outline",
    d: "M18.9,2.128,6.744,10.972H31.064L18.9,2.128m0-1.655a1.022,1.022,0,0,1,.6.2l13.733,9.987a1.023,1.023,0,0,1-.6,1.85H5.171a1.023,1.023,0,0,1-.6-1.85L18.3.669A1.022,1.022,0,0,1,18.9.473Z",
    transform: "translate(303.344 149.57)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1",
    "data-name": "Line 1",
    d: "M-.733,9.241A.767.767,0,0,1-1.5,8.473V-.733A.767.767,0,0,1-.733-1.5a.767.767,0,0,1,.767.767V8.473A.767.767,0,0,1-.733,9.241Z",
    transform: "translate(313.007 165.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    "data-name": "Line 2",
    d: "M-.733,9.241A.767.767,0,0,1-1.5,8.473V-.733A.767.767,0,0,1-.733-1.5a.767.767,0,0,1,.767.767V8.473A.767.767,0,0,1-.733,9.241Z",
    transform: "translate(332.954 165.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    "data-name": "Line 3",
    d: "M-.733,9.241A.767.767,0,0,1-1.5,8.473V-.733A.767.767,0,0,1-.733-1.5a.767.767,0,0,1,.767.767V8.473A.767.767,0,0,1-.733,9.241Z",
    transform: "translate(322.98 165.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16_-_Outline",
    "data-name": "Rectangle 16 - Outline",
    d: "M2.557,1.534a1.023,1.023,0,0,0,0,2.046H26.084a1.023,1.023,0,0,0,0-2.046H2.557M2.557,0H26.084a2.557,2.557,0,0,1,0,5.115H2.557A2.557,2.557,0,1,1,2.557,0Z",
    transform: "translate(307.927 175.885)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinistriesNew);
export default __webpack_public_path__ + "static/media/ministries-new.99d56c28.svg";
export { ForwardRef as ReactComponent };